import { useEffect, useState } from "react";
import { Play } from "lucide-react";
import { mediaBlobUrl } from "@/lib/portalApi";
import { toast } from "sonner";

export default function VoicePlayer({ path, testid }) {
  const [url, setUrl] = useState(null);
  const [loading, setLoading] = useState(false);
  useEffect(() => () => { if (url) URL.revokeObjectURL(url); }, [url]);
  if (!path) return null;
  const load = async () => {
    if (url) return;
    setLoading(true);
    try { setUrl(await mediaBlobUrl(path)); } catch { toast.error("Couldn't load voice note."); } finally { setLoading(false); }
  };
  if (url) return <audio data-testid={testid} src={url} controls className="w-full max-w-[260px] mt-1" />;
  return (
    <button data-testid={testid ? `${testid}-play` : undefined} onClick={load} className="inline-flex items-center gap-2 mt-1 text-sm text-[#A9724E] hover:underline">
      <Play className="w-4 h-4" strokeWidth={1.5} />{loading ? "Loading…" : "Play voice note"}
    </button>
  );
}
